import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Typography,
} from "@material-ui/core";
import { Translator } from "@itarget/shared";
import SubHeaderDetails from "./SubHeaderDetails";
import StepBlock from "./StepBlock";
import VideoList from "./VideoList";
import { useStyles } from "./styles";

const ProgramingOnDemandHeader = () => {
  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <CardHeader
        title={Translator({ transRef: "translation.On Demand" })}
        subheader={Translator({
          transRef: "translation.Este é seu acervo de aulas gravadas!",
        })}
      />
    </Card>
  );
};

const StepContent = ({
  title,
  indexTitle,
  steps,
  programingGrouped,
  selectStep,
  openQuestionFromCurrentLessonWithQuestionId,
  settingCommerce,
  isLoadingDetail,
  loadFinalResults,
  finalResultsByScheduleId,
}) => {
  const classes = useStyles();
  const currentSteps = steps[title];

  if (!currentSteps) return null;

  return (
    <Card className={classes.root}>
      <CardContent className={classes.stepContainer}>
        <Typography variant="h6" className={classes.stepTitle}>
          {`${indexTitle + 1} - ${title}`}
        </Typography>

        <SubHeaderDetails
          details={programingGrouped.data.pelestrante_header[title]}
        />

        <Divider className={classes.divider} />

        {Object.entries(currentSteps).map(([date, stepData]) => {
          const hasValidSteps =
            Object.keys(stepData).filter((step) => step !== "").length > 0;

          return (
            <div key={date}>
              {hasValidSteps && <StepBlock date={date} steps={stepData} />}

              <VideoList
                videoData={stepData}
                selectStep={selectStep}
                settingCommerce={settingCommerce}
                isLoadingDetail={isLoadingDetail}
                loadFinalResults={loadFinalResults}
                openQuestionFromCurrentLessonWithQuestionId={
                  openQuestionFromCurrentLessonWithQuestionId
                }
                finalResultsByScheduleId={finalResultsByScheduleId}
              />
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
};

const ProgramingOnDemand = ({
  programingGrouped,
  steps = [],
  selectStep,
  openQuestionFromCurrentLessonWithQuestionId,
  settingCommerce,
  isLoadingDetail,
  loadFinalResults,
  finalResultsByScheduleId,
}) => {
  const classes = useStyles();

  return (
    <>
      <ProgramingOnDemandHeader />
      <Divider className={classes.divider} />
      <div>
        {Object.keys(steps).map((title, indexTitle) => (
          <StepContent
            key={title}
            title={title}
            indexTitle={indexTitle}
            steps={steps}
            programingGrouped={programingGrouped}
            selectStep={selectStep}
            settingCommerce={settingCommerce}
            isLoadingDetail={isLoadingDetail}
            openQuestionFromCurrentLessonWithQuestionId={
              openQuestionFromCurrentLessonWithQuestionId
            }
            loadFinalResults={loadFinalResults}
            finalResultsByScheduleId={finalResultsByScheduleId}
          />
        ))}
      </div>
    </>
  );
};

export default ProgramingOnDemand;
